import {PriceGuaranteeHintSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {COLORS, GenericIconName, Icon, Text} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {BestPriceHintFlyout} from './BestPriceHintFlyout';
import {useBestPriceHintStateOpener} from './useBestPriceHintStateOpener';
import {useTrackBestPriceHint} from './useTrackBestPriceHint';

export const BestPriceHintSectionView: React.FC<PriceGuaranteeHintSection> = ({
  flyout,
  headline,
  tracker,
}) => {
  const {open} = useBestPriceHintStateOpener();
  const {infoIconRef, trackInfoClick, trackLearnMoreClick} =
    useTrackBestPriceHint(tracker.name);

  const handleOpenFlyout = () => {
    trackInfoClick();
    open();
  };

  return (
    <>
      <AnimateHeight data-testid="bestPriceHintSection">
        <Wrapper>
          <InnerWrapper>
            <Icon asset={GenericIconName.BestPriceGuaranteeWallet} size="XS" />
            <StyledText size="px10">{headline}</StyledText>
          </InnerWrapper>
          <span ref={infoIconRef}>
            <Icon
              data-testid="bestPriceInfoIcon"
              asset={GenericIconName.InfoFilledGray}
              onClick={handleOpenFlyout}
              size="XS"
              fill={COLORS.Grey0}
            />
          </span>
        </Wrapper>
      </AnimateHeight>
      <BestPriceHintFlyout {...flyout} onLearnMoreClick={trackLearnMoreClick} />
    </>
  );
};

const AnimateHeight = styled.div`
  overflow: hidden;
  height: 33px;
`;

const Wrapper = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
  padding: 8px 16px;
  border-bottom: 1px solid ${COLORS.Grey3};
`;

const InnerWrapper = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  gap: 8px;
  justify-content: center;
`;

const StyledText = styled(Text)`
  line-height: 16px;
`;
